"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Localization = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const provider_settings_1 = require("@framework/provider-settings");
const Localization = props => {
    const { languages, icon, menuProps = {}, menuItemProps = {} } = props;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const settings = (0, provider_settings_1.useSettings)();
    const [anchor, setAnchor] = (0, react_1.useState)(null);
    const handleLanguageIconClick = (e) => {
        setAnchor(e.currentTarget);
    };
    const handleLanguageMenuClose = () => {
        setAnchor(null);
    };
    const handleLanguageMenuItemClick = (language) => () => {
        settings.setLanguage(language);
        document.documentElement.setAttribute("lang", language);
        handleLanguageMenuClose();
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: formatMessage({ id: "components.header.language.switch" }), enterDelay: 300, children: (0, jsx_runtime_1.jsx)(material_1.IconButton, { color: "inherit", "aria-owns": anchor ? "language-menu" : undefined, "aria-haspopup": "true", onClick: handleLanguageIconClick, "data-testid": "switchLanguage", children: icon || (0, jsx_runtime_1.jsx)(icons_material_1.Translate, {}) }) }), (0, jsx_runtime_1.jsx)(material_1.Menu, { id: "language-menu", anchorEl: anchor, open: !!anchor, onClose: handleLanguageMenuClose, ...menuProps, children: languages.map(language => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { selected: settings.getLanguage() === language, onClick: handleLanguageMenuItemClick(language), ...menuItemProps, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `enums.language.${language}` }) }, language))) })] }));
};
exports.Localization = Localization;
//# sourceMappingURL=index.js.map